import React from "react";
import { Route, Switch } from "react-router-dom";
import AboutUs from "../Views/AboutUs/Index";
import Countries from "../Views/Countries/Index";
import ContactUs from "../Views/ContactUs/Index";
import Progress from "../Views/Progress/Index";
import Eligibility from "../Views/Eligibility/Eligibility";
import CheckEligibility from "../Views/CheckEligibility/Index";
import DegreeAttestation from "../Views/Services/DegreeAttestation/DegreeAttestation";
import Ielts from "../Views/Services/Ilets/Ilets";
import Immigration from "../Views/Services/Immigration/Immigration";
import NotFound from "../Views/NotFound/NotFound";
const router = (props) => {
  return (
    <>
      <Switch>
        <Route path="/aboutus">
          <AboutUs />
        </Route>
        <Route path="/contactus">
          <ContactUs />
        </Route>
        <Route path="/progress">
          <Progress />
        </Route>
        <Route path="/eligibility/:contary">
          <Eligibility />
        </Route>
        <Route path="/checkeligibility">
          <CheckEligibility />
        </Route>
        <Route path="/services/degreeattestation">
          <DegreeAttestation />
        </Route>
        <Route path="/services/ielts">
          <Ielts />
        </Route>
        <Route path="/services/immigration">
          <Immigration />
        </Route>
        <Route exact path="/">
          <Countries />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </>
  );
};

export default router;
